import React from "react";
interface TextFieldProps extends React.InputHTMLAttributes<HTMLInputElement> {
  id: string;
  label: string;
  error?: string;
}
export function TextField({
  id,
  label,
  error,
  className = "",
  ...props
}: TextFieldProps) {
  return <div className={className} data-id="element-323" data-mp="9jfve123rw87">
      <label htmlFor={id} className="block text-sm font-medium text-ink" data-id="element-324" data-mp="5jdqzk4zgop8">
        {label}
      </label>
      <input id={id} aria-invalid={Boolean(error)} aria-describedby={error ? `${id}-error` : undefined} className={`mt-1.5 block w-full rounded-xl border bg-white px-4 py-3 text-sm text-ink placeholder:text-muted/60 transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-brand/20 ${error ? "border-danger focus:border-danger" : "border-line focus:border-brand"}`} {...props} data-id="element-325" data-mp="kay0y2a28xm" />
      {error && <p id={`${id}-error`} className="mt-1.5 text-xs text-danger" data-id="element-326" data-mp="1ky1p4dukagpx">
          {error}
        </p>}
    </div>;
}